<template>
<MainLayout501 selectMenu="50-1" sideBar="machine" siderMenu="501-3">
    <Tabs v-model="selectTab" type="card" class="custom-tabs">
        <TabPane label="焊接控制" name="m1" class="custom-tabpane">
            <WeldControl v-if="selectTab == 'm1'" :mac="mac"></WeldControl>
        </TabPane>
        <TabPane label="修磨" name="m2" class="custom-tabpane">
            <TipDressing v-if="selectTab == 'm2'" :mac="mac"></TipDressing>
        </TabPane> 
        <TabPane label="位置录入" name="m3" class="custom-tabpane">
            <MoveRecord v-if="selectTab == 'm3'" :mac="mac"></MoveRecord>
        </TabPane>        
    </Tabs>
</MainLayout501>
</template>

<script>
import MainLayout501 from '@/components/501/MainLayout.vue'
import {mapGetters} from 'vuex'
import WeldControl from './components/WeldControl.vue'
import TipDressing from './components/TipDressing.vue'
import MoveRecord from './components/MoveRecord.vue'
export default {
    name: 'ControllerIndex',
    components: {
        MainLayout501,WeldControl,TipDressing,MoveRecord
    },
    data() {
        return {          
            mac: '',
            selectTab:'',
        }
    },
    computed: {
      ...mapGetters(['getTranslation']),
    },
    watch: {
        selectTab(newVal) {
            if (newVal) {
                localStorage.setItem('control501.selectTab', newVal);
            }
        }
    },
    mounted() {

    },
    beforeDestroy() {

    },
    created() {
        this.mac = this.$route.query.mac   
        this.selectTab = localStorage.getItem('control501.selectTab') || 'm1';     
    },
    methods: {
      
        

    }
}
</script>

<style scoped>

</style>

